type AuthorizedUser = {
  email?: string;
  hasStrongAuthentication?: boolean;
  impersonatorEmail?: string;
  impersonatorUserToken?: string;
  isInitialMultiFactorAuthenticationRequired?: boolean;
  isLoggedIn: boolean;
  roles?: Array<string>;
  userToken?: string;
};

export function isAuthorized<User>(options: {
  mapUser: (user: User) => AuthorizedUser;
  requireStrongAuthentication?: boolean;
}): (user: User) => boolean;
export function isAuthorized<User extends AuthorizedUser = AuthorizedUser>(options?: {
  requireStrongAuthentication?: boolean;
}): (user: User) => boolean;
export function isAuthorized<User>(options?: {
  mapUser?: (user: User) => AuthorizedUser;
  requireStrongAuthentication?: boolean;
}) {
  const { mapUser, requireStrongAuthentication } = options ?? {};

  return (user: User) => {
    const {
      email,
      hasStrongAuthentication,
      impersonatorEmail,
      impersonatorUserToken,
      isInitialMultiFactorAuthenticationRequired,
      isLoggedIn,
      userToken,
    } = mapUser ? mapUser(user) : (user as unknown as AuthorizedUser);

    const isImpersonating = impersonatorEmail && impersonatorUserToken;

    if (!isLoggedIn || (!isImpersonating && isLoggedIn && !email && !userToken)) {
      return false;
    } else if (isImpersonating) {
      return true;
    } else if (isInitialMultiFactorAuthenticationRequired) {
      return false;
    } else if (requireStrongAuthentication && !hasStrongAuthentication) {
      return false;
    } else {
      return true;
    }
  };
}
